import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig'; // ⚠️ Pastikan path ini benar sesuai lokasi firebaseConfig Anda
import { collection, onSnapshot, doc, updateDoc, addDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import { Plus, Trash2, Edit2, Save, X, Palette, Type, Hash, Image as ImageIcon } from 'lucide-react';

export default function PromoCardsPage() {
  const [cards, setCards] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    iconName: 'people',
    colorHex: '0xFF448AFF',
    order: 1
  });

  // Load data real-time dari Firestore
  useEffect(() => {
    const q = query(collection(db, 'promo_cards'), orderBy('order', 'asc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setCards(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isEditing) {
        await updateDoc(doc(db, 'promo_cards', isEditing), formData);
        setIsEditing(null);
      } else {
        await addDoc(collection(db, 'promo_cards'), formData);
      }
      setFormData({ title: '', subtitle: '', iconName: 'people', colorHex: '0xFF448AFF', order: cards.length + 1 });
    } catch (error) {
      console.error("Error saving card:", error);
      alert("Gagal menyimpan data");
    }
    setLoading(false);
  };

  const deleteCard = async (id) => {
    if (window.confirm('Hapus kartu promo ini?')) {
      await deleteDoc(doc(db, 'promo_cards', id));
    }
  };

  const cancelEdit = () => {
    setIsEditing(null);
    setFormData({ title: '', subtitle: '', iconName: 'people', colorHex: '0xFF448AFF', order: cards.length + 1 });
  };

  return (
    <div className="text-gray-100">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white flex items-center gap-2">
          <ImageIcon className="text-blue-500" /> Manajemen Promo Cards
        </h2>
        <p className="text-gray-400 text-sm">Kelola tampilan box promosi di beranda aplikasi mitra.</p>
      </div>

      {/* FORM ENTRI */}
      <form onSubmit={handleSubmit} className="bg-gray-800/50 border border-gray-700 p-6 rounded-2xl mb-8 shadow-xl">
        <h3 className="text-sm font-semibold text-blue-400 mb-4 flex items-center gap-2">
          {isEditing ? <Edit2 size={16}/> : <Plus size={16}/>} 
          {isEditing ? 'Edit Kartu' : 'Tambah Kartu Baru'}
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-400 flex items-center gap-1"><Type size={12}/> Judul</label>
            <textarea 
              className="w-full bg-gray-950 border border-gray-700 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
              rows="2"
              placeholder="Contoh: Ajak Teman,\nDapat Bonus!"
              value={formData.title} 
              onChange={e => setFormData({...formData, title: e.target.value})} 
              required 
            />
          </div>

          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-400 flex items-center gap-1"><Type size={12}/> Subtitle</label>
            <input 
              className="w-full bg-gray-950 border border-gray-700 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
              value={formData.subtitle} 
              onChange={e => setFormData({...formData, subtitle: e.target.value})} 
              required 
            />
          </div>

          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-400 flex items-center gap-1"><ImageIcon size={12}/> Ikon (Sesuai Flutter)</label>
            <select 
              className="w-full bg-gray-950 border border-gray-700 rounded-lg p-2.5 text-sm outline-none"
              value={formData.iconName} 
              onChange={e => setFormData({...formData, iconName: e.target.value})}
            >
              <option value="people">People (Referral)</option>
              <option value="assignment">Assignment (Misi)</option>
              <option value="event">Event (Reward)</option>
            </select>
          </div>

          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-400 flex items-center gap-1"><Palette size={12}/> Warna Hex (Format: 0xFF...)</label>
            <input 
              className="w-full bg-gray-950 border border-gray-700 rounded-lg p-2.5 text-sm outline-none"
              value={formData.colorHex} 
              onChange={e => setFormData({...formData, colorHex: e.target.value})} 
            />
          </div>

          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-400 flex items-center gap-1"><Hash size={12}/> Urutan Tampil</label>
            <input 
              type="number"
              className="w-full bg-gray-950 border border-gray-700 rounded-lg p-2.5 text-sm outline-none"
              value={formData.order} 
              onChange={e => setFormData({...formData, order: parseInt(e.target.value)})} 
            />
          </div>

          <div className="flex items-end gap-2">
            <button 
              type="submit" 
              disabled={loading}
              className="flex-1 bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2.5 rounded-lg transition flex items-center justify-center gap-2"
            >
              {loading ? '...' : isEditing ? <><Save size={18}/> Update</> : <><Plus size={18}/> Tambah</>}
            </button>
            {isEditing && (
              <button 
                type="button"
                onClick={cancelEdit}
                className="bg-gray-700 hover:bg-gray-600 p-2.5 rounded-lg"
              >
                <X size={20}/>
              </button>
            )}
          </div>
        </div>
      </form>

      {/* PREVIEW LIST */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card) => (
          <div key={card.id} className="bg-gray-800 border border-gray-700 rounded-2xl p-5 relative overflow-hidden group">
            <div className="flex justify-between items-start mb-4">
              <div className="px-3 py-1 bg-gray-900 rounded-full text-[10px] font-bold text-blue-400 border border-blue-500/30">
                ORDER: {card.order}
              </div>
              <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition">
                <button onClick={() => { setIsEditing(card.id); setFormData(card); }} className="p-1.5 bg-blue-600/20 text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition">
                  <Edit2 size={14}/>
                </button>
                <button onClick={() => deleteCard(card.id)} className="p-1.5 bg-red-600/20 text-red-400 rounded-lg hover:bg-red-600 hover:text-white transition">
                  <Trash2 size={14}/>
                </button>
              </div>
            </div>

            <div className="space-y-2">
              <h4 className="text-lg font-bold text-white whitespace-pre-line leading-tight">
                {card.title}
              </h4>
              <p className="text-gray-400 text-xs">
                {card.subtitle}
              </p>
            </div>

            <div className="mt-6 pt-4 border-t border-gray-700 flex items-center justify-between">
               <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full" style={{backgroundColor: `#${card.colorHex.replace('0xFF', '')}`}}></div>
                  <span className="text-[10px] font-mono text-gray-500">{card.colorHex}</span>
               </div>
               <span className="text-[10px] text-gray-500 uppercase tracking-widest font-bold italic">{card.iconName}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}